<template>
	<div class="box widthCen">
		<div class="bai_view">
			<div class="my-title">支付中心</div>
			<div class="nei_box">
				<ul>
					<li class="flex float">
						<p>购买产品:</p>
						<div class="li_you flex">
							<div class="li_box flex">
								<img :src="cardInfo.PcCover" />
								<div class="gm_you">
									<p>{{ cardInfo.Name }}</p>
									<p style="margin: 10px 0;">￥{{ cardInfo.Price || '' }}</p>
									<span>
										有效期:
										<i>
											{{
												cardInfo.imeType == 1
													? '一年'
													: cardInfo.imeType == 2
													? '3个月'
													: cardInfo.imeType == 3
													? '2个月'
													: cardInfo.imeType == 4
													? '1个月'
													: cardInfo.imeType == 5
													? '15天'
													: cardInfo.imeType == 6
													? '7天'
													: cardInfo.imeType == 7
													? '3天'
													: cardInfo.imeType == 8
													? '1天'
													: '长期'
											}}
										</i>
										，使用次数：
										<i>{{ cardInfo.Unlimit ? '不限次' : cardInfo.Num + '次' }}</i>
									</span>
								</div>
							</div>
						</div>
					</li>

					<li class="flex float">
						<p>订购对象:</p>
						<div class="li_you flex"><el-input v-model="phone" type="number" maxlength="11" placeholder="请输入手机号" style="width: 260px;"></el-input></div>
					</li>
					<li class="flex float">
						<p>支付方式:</p>
						<div class="li_you flex">
							<div class="qr_img" @click="onApply(1)">
								<img src="../../image/gga.png" v-if="isApply == 1" />
								<div class="qr_pic"><img src="../../image/san/zfa.png" class="img_bai" /></div>
								<div class="flexCenter qr_fg">
									<img src="../../image/san/wx.png" />
									<span>微信支付</span>
								</div>
							</div>
							<div class="qr_img" @click="onApply(2)">
								<img src="../../image/gga.png" v-if="isApply == 2" />
								<div class="qr_pic" style="border-color: #66c8f3;"><img src="../../image/san/zf.png" class="img_bai" /></div>
								<div class="flexCenter qr_fg">
									<img src="../../image/san/wxba.png" />
									<span>支付宝支付</span>
								</div>
							</div>
						</div>
					</li>
					<li class="flex float">
						<p></p>
						<div class="li_you flex zhong">
							<img :src="isArgee ? require('../../image/aa.png') : require('../../image/a.png')" @click="isArgee = !isArgee" />
							<p>
								我已阅读并同意
								<span @click="agree()">《服务条款及免责声明》</span>
							</p>
						</div>
					</li>
					<div style="margin-left: 90px;"><el-button v-on:click="SubmitOrder">立即购买</el-button></div>
				</ul>
			</div>
		</div>
		<div class="flexCenter popup" v-if="isercode">
			<div class="qr_bai">
				<img src="../../image/del.png" class="delimg" @click="isercode = false" />
				<div class="qr_img"><vue-qr :value="payUrl" :options="{ size: 200 }"></vue-qr></div>
			</div>
		</div>

		<!-- 支付弹窗 -->
		<aside class="popup flexCenter" v-if="isWxPay">
			<div class="qr_box ">
				<div class="flexCenter">
					<div class="qr_imga" v-if="Ercode1">
						<img :src="Ercode1"/>
					</div>
					<div class="qr_imga" v-if="Ercode2">
						<img :src="Ercode2"/>
					</div>
					<div class="qr_imga" v-if="Ercode3">
						<img :src="Ercode3"/>
					</div>
				</div>
				<div class="flexCenter" style="padding-top: 20px;"><el-button type="primary" @click="isWxPay = false">关闭</el-button></div>
			</div>
		</aside>
	</div>
</template>
<script>
import vueQr from '@xkeshi/vue-qrcode';
import Cookies from 'js-cookie';
export default {
	name: 'media',
	components: {
		vueQr
	},
	data() {
		return {
			isWxPay: false,
			orderTime: null,
			isercode: false,
			isArgee: false,
			cardInfo: {},
			phone: '',
			isClick: false,
			isApply: 1,
			payUrl: '',
			Ercode1: '',
			Ercode2: '',
			Ercode3: ''
		};
	},
	mounted: function() {
		// this.cardInfo = this.$store.state.user.orderCard;
		var orderCardObj = sessionStorage.getItem('orderCardObj');
		if (orderCardObj) {
			this.cardInfo = JSON.parse(orderCardObj);
		}
		this.phone = this.$store.state.user.user.Phone;
	},
	beforeDestroy() {
		if (this.orderTime) {
			clearTimeout(this.orderTime);
		}
	},
	methods: {
		onApply(type) {
			console.log('选择', type);
			this.isApply = type;
		},
		agree() {
			this.isArgee = true;
			this.phone = this.$store.state.user.user.Phone;
			this.$store.state.user.orderCardInfo = {
				phone: this.phone,
				isArgee: this.isArgee,
				isApply: this.isApply
			};
			this.$router.push('/agree');
		},
		// 开始下单
		SubmitOrder: function() {
			var that = this;
			if (that.isClick) {
				return;
			}
			var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
			if (!that.phone || that.phone.length === 0) {
				that.$util.showError('请输入手机号');
				that.isClick = false;
				return;
			} else if (!myreg.test(that.phone)) {
				that.$util.showError('请填写正确的手机号码');
				that.isClick = false;
				return;
			}
			if (!that.isArgee) {
				that.$util.showError('请阅读协议');
				that.isClick = false;
				return;
			}
			that.isClick = true;
			const loading = this.$loading({
				lock: true
			});
			that.$api.HtppRequest(
				'Card/PrePay',
				'POST',
				{
					Client: 1,
					CardSaleId: that.cardInfo.Id,
					Phone: that.phone,
					PayWay: that.isApply // 支付方式 1.微信 2.支付宝
				},
				function(res) {
					loading.close();
					console.log('拉起支付', res);
					if (res.code==0) {
						if (that.isApply == 1) {
							if(res.type==0){
								that.isercode = true;
								that.payUrl = res.result.code_url;
								that.isClick = false;
								// 遍历订单状态
								that.getOrderState(res.orderId);
							}
							if(res.type==1){
								if (res.Ercode1.length == 0 && res.Ercode2.length == 0 && res.Ercode3.length == 0) {
									that.$util.showOk('请联系管理员');
								} else {
									that.isWxPay = true;
									that.Ercode1 = res.Ercode1;
									that.Ercode2 = '';
									that.Ercode3 = res.Ercode3;
								}
								that.isClick = false;
							}
							if(res.type==2){
								that.$util.showOk(res.msg);
								that.isClick = false;
							}
						} else {
							// 支付宝支付 生成二维码
							// that.payUrl = res.data.QrCode;
							// that.isercode = true;
							// // 遍历订单状态
							// that.getOrderState(res.orderId);
							if(res.type==0){
								that.isercode = true;
								that.payUrl = res.data.QrCode;
								that.isClick = false;
								// 遍历订单状态
								that.getOrderState(res.orderId);
							}
							if(res.type==1){
								if (res.Ercode1.length == 0 && res.Ercode2.length == 0 && res.Ercode3.length == 0) {
									that.$util.showOk('请联系管理员');
								} else {
									that.isWxPay = true;
									that.Ercode1 = '';
									that.Ercode2 = res.Ercode2;
									that.Ercode3 = '';
								}
								that.isClick = false;
							}
							if(res.type==2){
								that.$util.showOk(res.msg);
								that.isClick = false;
							}
						}
					} else {
						that.$util.showError(res.msg);
						that.isClick = false;
						return;
					}
				},
				function(res) {
					loading.close();
				}
			);
		},
		getOrderState(oid) {
			var that = this;
			that.orderTime = setTimeout(() => {
				that.$api.HtppRequest(
					'Card/Detail?id=' + oid,
					'GET',
					{},
					function(res) {
						console.log('订单状态', res);
						if (res.code == 0) {
							if (res.data.isPay) {
								console.log('支付成功');
								that.$util.showOk('支付成功');
								setTimeout(() => {
									that.$router.push('/service');
								}, 1500);
							} else {
								that.getOrderState(oid);
							}
						}
					},
					function(res) {}
				);
			}, 1000);
		}
	}
};
</script>
<style lang="scss" scoped>
	.qr_img-li{
		width: 150px;
		height: 150px;
	}
	.qr_img-li img{
		width: 100%;
		height: 100%;
		display: block;
	}
.qr_imga img {
	width: 100%;
	height: 148px;
	display: block;
}

.qr_imga p {
	text-align: center;
	font-size: 16px;
	color: #000;
	padding-top: 15px;
}

.qr_imga {
	width: 180px;
	padding: 15px;
	border: solid 1px #f5f5f5;
	border-radius: 10px;
	box-sizing: border-box;
	margin-right: 20px;
}

.qr_imga:last-child {
	margin-right: 0;
}

.qr_box {
	box-sizing: border-box;
	width: 660px;
	background-color: #fff;
	border-radius: 10px;
	padding: 40px;
}

.delimg {
	width: 30px;
	height: 30px;
	position: absolute;
	right: 5px;
	top: 5px;
	z-index: 1;
	cursor: pointer;
}

.qr_img {
	width: 1005;
}

.qr_bai {
	position: relative;
	background-color: #fff;
	border-radius: 14px;
	padding: 30px 20px 20px 20px;
	width: 240px;
	box-sizing: border-box;
}

.qr_fg {
	font-size: 14px;
	color: #000;
	margin-top: 20px;
}

.qr_img a {
	width: 160px;
	height: 40px;
	display: block;
	font-size: 14px;
	color: #fff;
	text-align: center;
	line-height: 40px;
	background-color: #02a9f1;
	margin-top: 10px;
}

.qr_fg img {
	display: block;
	width: 20px;
	height: 20px;
	margin-right: 10px;
}

.qr_img {
	width: 160px;
	position: relative;
	margin-right: 48px;
}

.qr_img > img {
	position: absolute;
	right: 0;
	top: 0;
	z-index: 1;
}

.qr_pic img {
	display: block;
	width: 100%;
	height: 100%;
}

.qr_pic {
	width: 100%;
	height: 160px;
	background-color: #fff;
	padding: 20px;
	box-sizing: border-box;
	border: solid 1px #6fc04c;
}

.li_you p span {
	color: #005371;
	cursor: pointer;
}

.li_you p {
	font-size: 14px;
	color: #333333;
}

.li_you > img {
	display: block;
	width: 33px;
	height: 33px;
	cursor: pointer;
	margin-right: 0px;
}

.gm_you span {
	font-size: 14px;
	color: #666666;
}

.gm_you span i {
	color: #000;
	font-style: normal;
}

.gm_you p {
	font-size: 14px;
	color: #000;
}

.gm_you {
	width: calc(700px - 182px);
	height: 100%;
	border: solid 1px #ebebeb;
	padding: 20px;
	box-sizing: border-box;
}

.li_box img {
	width: 182px;
	height: 128px;
	display: block;
}

.li_box {
	height: 128px;
}

.li_you {
	width: calc(100% - 82px);
}

.nei_box li > p {
	font-size: 14px;
	color: #1a1a1a;
	line-height: 40px;
}

.nei_box li {
	padding-top: 35px;
}

.nei_box {
	padding: 0 30px;
}

.bai_view {
	background-color: #fff;
	padding: 0 18px 50px 18px;
}

.box {
	padding: 20px 0;
}
</style>
